import styled from "styled-components";
import { SPACING } from "../../../../../utils/constants";
import { ImpactTone } from "./types";

const TONE_COLORS: Record<ImpactTone, string> = {
  expense: "var(--color-error)",
  income: "var(--color-success)",
  transfer: "var(--color-info)",
  loan: "var(--color-purple)",
};

export const ImpactList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ImpactItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  line-height: 1.3;
  color: var(--color-text-secondary);
`;

export const ImpactIcon = styled.span<{ $tone: ImpactTone }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ $tone }) => TONE_COLORS[$tone]};

  svg {
    font-size: var(--text-lg);
  }
`;

export const ImpactCount = styled.span`
  min-width: 3.2ch;
  font-weight: 700;
  text-align: right;
  color: var(--color-text-default);
`;

export const SuccessPanel = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  margin-top: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  border-radius: 12px;
  background: var(--color-success-background);
  border: 1px solid var(--color-success-border);
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  line-height: 1.4;
  color: var(--color-success);

  svg {
    flex-shrink: 0;
    font-size: var(--text-lg);
  }
`;

export const LoadingPanel = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  margin-top: ${SPACING.md}px;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
`;

export const FootNote = styled.p`
  margin: ${SPACING.md}px 0 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  line-height: 1.5;
  color: var(--color-text-secondary);

  strong {
    color: var(--color-text-default);
  }
`;
